<template>
  <div v-wechat-title="titleTop">
    <template v-if="data && data.team.isEnable">
      <div class="topBar">
        <TopBar :pagetitle="title" :back-url="backurl" right="iconbangzhu" @rightClick="onHelp" />
      </div>

      <div class="topRect">
        <img src="/grouptest/xmas2019socks_sky.png">
      </div>
      <div class="bottonRect">
        <img src="/grouptest/xmas2019socks_land.png">
      </div>
      <div class="box">
        <img :src="giftData && giftData.isHaveGift?'/grouptest/xmas2019socks_box.png':'/grouptest/xmas2019socks_boxE.png'">
      </div>
      <div class="downButton">
        <van-button v-if="giftData && !giftData.isHaveGift" style="width:60%;left:20%;" round :color="GetColorMain()" @click="onOpenGiftBox(false)">获取礼物</van-button>
        <van-button v-if="giftData && giftData.isHaveGift" style="width:60%;left:20%;" round :color="GetColorMain()" @click="onOpenGiftBox(false)">查看我的礼物</van-button>
      </div>
    </template>
    <template v-if="data && !data.team.isEnable">
      活动尚未开始
    </template>
    <let-it-snow
      v-bind="conf"
      :show="show"
    />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
    <van-overlay :show="showGiftBox" z-index="100002" @click="showGiftBox = false">
      <div class="wrapper">
        <div id="giftBox" class="block" @click.stop>
          <div class="boxRect">
            <img :src="(giftData && giftData.gift &&giftData.gift.icon?giftData.gift.icon:'/img/defaultcom.jpg')">
          </div>
          <div v-if="giftData && giftData.gift" class="title">{{ giftData.gift.name }}</div>
          <div v-if="giftData && !giftData.isGetGift" class="buttons">
            <van-button style="width:50%;" color="#EEC082" @click="onShareGift">转赠礼物</van-button>
            <van-button style="width:50%;" color="#DC383A" @click="onBuyGift">立即使用</van-button>
          </div>
          <div v-if="giftData && giftData.isGetGift" class="buttons">
            <van-button style="width:100%;" color="#DC383A" :loading="buttonLoading" @click="onGetGift">领取{{ giftData.gift.sendName }}赠送的礼物</van-button>
          </div>
        </div>
      </div>
    </van-overlay>
    <div id="dialogTop" style="z-index:100111; position: absolute;" />
  </div></template>
<script>
import request from '@/utils/request'
import { Button, Overlay, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { getUrlKey, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import LetItSnow from 'vue-let-it-snow'
import commonData from '@/commondata.js'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    TopBar,
    wxShare,
    LetItSnow
  },
  inject: ['reload'],
  data() {
    return {
      key: undefined,
      id: undefined,
      titleTop: '',
      title: '2019圣诞惊喜酷袜',
      backurl: '/store/index',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      data: undefined,
      giftData: undefined,
      joinData: undefined,
      conf: undefined,
      buttonLoading: false,
      boxConf: {
        windPower: 1,
        speed: 1,
        count: 10,
        size: 8,
        opacity: 1,
        images: ['/grouptest/box0.png']
      },
      starConf: {
        windPower: 0,
        speed: 0.2,
        count: 100,
        size: 2,
        opacity: 1,
        images: ['/grouptest/round0.png']
      },
      show: false,
      isBox: true,
      showGiftBox: false
    }
  },

  created() {
    this.key = this.$route.params.key
    this.id = getUrlKey('id')
    this.titleTop = GetSysTitle()
    this.init()
    this.getActivity((data) => {
      this.giftData = data
      // if (data.isHaveGift || data.isGetGift) {
      //   this.conf = this.starConf
      // } else {
      //   this.conf = this.boxConf
      // }
      // console.log('动画参数:', this.conf)
      this.conf = this.starConf
      setTimeout(() => {
        this.show = true
      }, 10)
      if (data.isGetGift) {
        if (!data.gift) {
          Dialog.confirm({
            getContainer: '#dialogTop',
            title: '礼物不见啦！',
            message: '这个礼物没有啦！不要紧，领取圣诞袜，圣诞老人每天派发惊喜礼物哦！'
          }).then(() => {
            this.onHelp()
          })
          // Dialog.confirm({
          //   title: '晚了一步',
          //   message: '礼物已经被其他人领走了。现在加入活动，圣诞老人每晚发放礼物！'
          // }).then(() => {
          //   this.onHelp()
          // })
        } else {
          this.onOpenGiftBox(true)
        }

        if (data.isHaveGift) {
          Dialog.confirm({
            getContainer: '#dialogTop',
            title: '你的袜子已经装满礼物了',
            message: '袜子已经满了，不能接收别人的礼物了，赶快使用掉或者赠送给别人吧！',
            confirmButtonText: '查看我的礼物'
          }).then(() => {
            this.$router.push('/group/giftBox/' + this.key)
            this.reload()
            return
          })
        }
      }
    })
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onHelp(id) {
      if (id) {
        this.$router.push('/group/group/' + this.key + '?id=' + id)
      } else {
        this.$router.push('/group/group/' + this.key)
      }
    },
    onShareFinish() {
      this.shareUrl = undefined
    },
    onOpenGiftBox(justOpen) {
      console.log('onOpenGiftBox', justOpen)
      console.log('onOpenGiftBox', this.giftData)
      if (justOpen) {
        this.showGiftBox = true
        return
      }
      if (this.giftData.isHaveGift) {
        this.showGiftBox = true
        return
      }
      if (this.giftData.isJoin) {
        Dialog.alert({
          getContainer: '#dialogTop',
          title: '你的圣诞袜是空的',
          message: '你的圣诞袜已空空，可以接受小伙伴的转赠礼物，或者等待圣诞老人明天的礼物吧！'
        })
      } else {
        Dialog.confirm({
          getContainer: '#dialogTop',
          title: '你是潜水员吗?',
          message: '这是潜水员专属的圣诞礼物，请先验证潜水员身份后吧!'
        }).then(() => {
          this.onHelp()
        })
      }
    },
    onGetGift() {
      console.log('onGetGift', this.giftData)
      if (this.giftData.isJoin) {
        if (this.giftData.isHaveGift) {
          Dialog.alert({
            getContainer: '#dialogTop',
            title: '你的圣诞袜已装满礼物！',
            message: '礼物必须用掉后才能接受礼物哦，赶快用掉或转赠吧！'
          })
          return
        }
        if (!this.giftData.isGiftSuccess) {
          Dialog.alert({
            getContainer: '#dialogTop',
            title: '礼物已被他人领走',
            message: '来晚了！不要紧，去寻找其他小伙伴的转赠礼物吧！'
          })
          return
        }
        // 领取袜子操作
        // Dialog.confirm({
        //   getContainer: '#dialogTop',
        //   title: '确定领取奖品吗?',
        //   message: '是否要确定领取这个奖品?'
        // }).then(() => {
        //   this.takeGroupTimeGift()
        // })
        this.takeGroupTimeGift()
        return
      }
      if (this.giftData.isGiftSuccess) {
        Dialog.confirm({
          getContainer: '#dialogTop',
          title: '你是潜水员吗?',
          message: '这是潜水员专属的圣诞礼物，请先验证潜水员身份后吧!'
        }).then(() => {
          this.onHelp(this.id)
        })
      } else {
        Dialog.confirm({
          getContainer: '#dialogTop',
          title: '礼物已被他人领走',
          message: '来晚了！不要紧，领取圣诞袜，圣诞老人每天派发惊喜礼物哦！'
        }).then(() => {
          this.onHelp()
        })
      }
    },
    takeGroupTimeGift() {
      this.buttonLoading = true
      request({
        url: '/StoreHelper/takeGroupTimeGift',
        method: 'post',
        data: {
          key: this.key,
          id: this.id
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        Dialog.alert({
          getContainer: '#dialogTop',
          title: '礼物已成功获得！',
          message: '礼物用掉后，才能继续接受转赠礼物，或者等待圣诞老人明天的惊喜，赶快用掉或转赠吧！'
        }).then(() => {
          this.$router.push('/group/giftBox/' + this.key)
          this.reload()
        })
      })
    },
    init() {
      request({
        url: '/StoreHelper/getGroupBuy',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.shareTitle = this.data.team.shareTitle
        this.shareAbout = this.data.team.shareAbout
        this.shareTimeline = this.data.team.shareTimeline
        this.shareIcon = this.data.team.shareIcon
        this.shareUrl = GetSelfUrl() + 'group/group/' + this.key + '?system=' + this.system
        this.title = this.data.team.shortName
      })
    },
    getActivity(callback) {
      request({
        url: '/StoreHelper/getGroupTimeGift',
        method: 'post',
        data: {
          key: this.key,
          id: this.id
        }
      }).then(response => {
        if (!response.success) {
          return
        }
        if (callback) {
          commonData.activityData = response.data
          commonData.activityData.isRead = true
          callback(response.data)
        }
      })
    },
    joinGroupTeam(callback) {
      request({
        url: '/StoreHelper/joinGroupTeam',
        method: 'get',
        params: { key: this.key }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.joinData = response.data
        if (callback) {
          callback()
        }
      })
    },
    onBuyGift() {
      if (this.giftData.gift.orderId) {
        this.$router.push('/store/order/' + this.giftData.gift.orderId)
      } else {
        var data = this.giftData.gift.commodityId + '|1|' + this.giftData.gift.specificationId + '||||||'
        this.$router.push('/store/ordercreate?data=' + data + '&activity=1')
      }
    },
    onShareGift() {
      this.$router.push('/group/giftBoxShare/' + this.key + '?id=' + this.giftData.gift.couponHashCode + '&icon=' + encodeURIComponent(this.giftData.gift.icon))
      // Dialog.confirm({
      //   getContainer: '#dialogTop',
      //   title: '赠送礼物',
      //   message: '是否要将该礼物赠送给别人?'
      // }).then(() => {
      //   this.$router.push('/group/giftBoxShare/' + this.key + '?id=' + this.giftData.gift.couponHashCode + '&icon=' + encodeURIComponent(this.giftData.gift.icon))
      // })
    }
  }
}
</script>
<style scoped>
.topBar{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3em;
  z-index: 100000;
}
.topRect{
    background-color: #13334C;
    height: 40em;
    margin-top: 3em;
}
.topRect img{
    width: 100%;
    display: block;
}
.bottonRect{
    position: absolute;
    top: 30em;
    z-index: 100000;
}
.bottonRect img{
    width: 100%;
    display: block;
}
.box{
  position: absolute;
  top: 28em;
  z-index: 100001;
  text-align: center;
  width: 100%;
  text-align: center;
}
.box img{
  width: 30%;
}

.downButton{
  position: fixed;
  bottom: 1em;
  width: 100%;
  z-index: 100001;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  border-radius: 0.4em;
  width: 87vw;
  height: 100vw;
  background-color: #fff;
  padding: 6px;
  position: relative;
  background-image: url('/grouptest/xmas2019socks_sweet.png') ;
  background-size:100%;
}
.block .boxRect{
  position: absolute;
  width: 56vw;
  height: 56vw;
  background-color: #cacaca;
  left: 17vw;
  top:20vw;
  padding: 0;
}
.block .boxRect img{
  width: 100%;
}
.block .buttons{
  position: absolute;
  bottom:6px;
  left: 6px;
  right: 6px;
}

.block .title{
  position: absolute;
  font-size: 0.9em;
  top:75%;
  left: 5%;
  width: 90%;
  text-align:  center;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
